import { addParamsToURL, proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { SectorHeatmapResponse } from '../entities';
import { ScannerEnvironment } from '../environment';
import { ScannerProtos } from '../scanner_protos';
import { scannerRoutes } from './routes';
import { ScannerTransport } from './types';

export class ScannerRestful extends RestfulClient implements ScannerTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(ScannerEnvironment);
    super(env.equityUrl, session, {}, proxyClientOptions());
  }

  getScannerInstruments = async (
    query: Omit<ScannerProtos.Query, 'toJSON'>,
    source: 'stocks' | 'crypto' = 'stocks',
  ): SafePromise<Response> => {
    const env = this.session.getEnvironment(ScannerEnvironment);
    const queryParams = {
      fields: query.fields.join(','),
      filter: query.filtersAsString ? query.filtersAsString.split(';') : undefined,
      limit: query.limit || 10,
      offset: query.offset,
      sortDir: ScannerProtos.SortDir[query.sortDir],
      sortField: query.sortField || undefined,
      ...(this.usingProxy ? { source } : { apikey: env.key }),
    };

    const requestUrl = this.usingProxy
      ? addParamsToURL(
          new URL(this.routePath(scannerRoutes.instruments), source === 'stocks' ? env.equityUrl : env.cryptoUrl),
          queryParams,
        )
      : this.URL(source === 'stocks' ? env.equityUrl.toString() : env.cryptoUrl.toString(), queryParams);

    return this.getProtoBuf(requestUrl, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      resilience: { delayMultiple: 5000, delayOffset: 3000, maxNumOfAttempts: 3 },
    });
  };

  getSectorHeatmap = async (): SafePromise<SectorHeatmapResponse> => {
    const hostname = this.session.getEnvironment(ScannerEnvironment).sectorHeatmapUrl;
    const url = this.URL(`${hostname}/embed/api/sector-heatmap`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
